module.exports = __webpack_public_path__ + "static/media/Wool.f9901ba4.svg";